import { Pipe, PipeTransform } from '@angular/core';
import type { FileFindInterface } from '@zaoblako/shared/modules/storage/dtos/file/file-find.dto';

@Pipe({
  standalone: true,
  name: 'fileUrl'
})
export class FileUrlPipe implements PipeTransform {
  public transform(file: FileFindInterface): string {
    return `basis/storage/file/${file?.path || file?.id}`
  }
}
